import { Navigate, Outlet, useLocation } from 'react-router'

import { useAuth } from '@/features/auth/auth-context'
import { FullPageSpinner } from '@/components/common/full-page-spinner'

/**
 * Route guard for authenticated areas.
 *
 * This is a convenience, not a security boundary. The security boundary
 * is Row Level Security in Postgres; a user who defeats this component
 * sees an empty application, not somebody's family archive. Keeping that
 * distinction clear is what stops client-side guards from quietly
 * becoming load-bearing.
 */
export function RequireAuth() {
  const { isAuthenticated, isLoading } = useAuth()
  const location = useLocation()

  if (isLoading) return <FullPageSpinner label="Checking your session…" />

  if (!isAuthenticated) {
    // Preserve where they were going so the sign-in redirect lands them
    // back on the photo their cousin linked them to.
    return <Navigate to="/sign-in" state={{ from: location.pathname + location.search }} replace />
  }

  return <Outlet />
}
